import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { handleAuthorizationCallback } from "@/services/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    let mounted = true;

    async function completeLogin() {
      try {
        await handleAuthorizationCallback();
        // Full reload so AuthContext re-runs its checks with the fresh token.
        window.location.replace("/");
      } catch (err) {
        if (!mounted) return;
        setError(err.message || "Authentication failed");
        setTimeout(() => navigate("/", { replace: true }), 3000);
      }
    }

    completeLogin();
    return () => {
      mounted = false;
    };
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white rounded-2xl shadow-xl ring-1 ring-black/5 p-8 w-full max-w-md text-center">
        {error ? (
          <p role="alert" className="text-sm text-destructive">
            {error} — Redirecting to login…
          </p>
        ) : (
          <div className="flex flex-col items-center gap-4">
            <div className="w-8 h-8 border-4 border-slate-200 border-t-slate-800 rounded-full animate-spin" />
            <p className="text-sm text-gray-500">Completing sign in…</p>
          </div>
        )}
      </div>
    </div>
  );
}
